import makeStyles from '@mui/styles/makeStyles';

const drawerWidth = 250;

const useStyles = makeStyles((theme) => ({
  hide: {
    display: 'none',
  },
  drawer: {
    zIndex: 99,
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    backgroundColor: '#26292E',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    backgroundColor: '#26292E',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: '65px',
  },
  toolbar: {
    background: '#000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 4px',
    ...theme.mixins.toolbar,
  },
  logo: {
    width: '100%',
    height: 'auto',
    maxHeight: '60px',
    maxWidth: '60px',
    padding: '0 0 0 6px',
  },
  iconContainer: {
    minWidth: '63px',
    display: 'flex',
    justifyContent: 'center',
  },
  listItemText: {
    fontSize: '13px',
    color: '#EAF2FF',
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  content: {
    flexGrow: 1,
    padding: 0,
    overflow: 'hidden',
  },
}));

export default useStyles;
